import { nodeTypes, START } from "./nodeTypes";
import { mrTypes } from "./mrTypes";
import { QUANTIFIER_MANY, QUANTIFIERS } from "../constants";
const nodesTypes = nodeTypes.concat(mrTypes);
export class ContextAnalyzer {
  constructor(nodes, links, testNode, models) {
    this.context = [];
    this.changeBaseData(nodes, links, testNode, models);
  }
  changeBaseData(nodes = null, links = null, testNode = null, models = null) {
    this.nodes = nodes ? nodes : this.nodes;
    this.links = links ? Object.keys(links).map((o) => links[o]) : this.links;
    this.testNode = testNode ? testNode : this.testNode;
    if (models && models.models) {
      this.models = models.models;
      this.modelsNames = this.models.map((o) => o.name);
    }
  }
  findRelatedContext() {
    if (this.testNode.type !== START) {
      const endLink = this.links.find((o) => o.to.nodeId === this.testNode.id);
      this.context = this.recursiveSearch(endLink, [], 0, []);
      return this.context;
    }
  }
  lastContext() {
    if (!this.context) {
      this.findRelatedContext();
    }
    return this.context;
  }
  recursiveSearch(currentLink, accumulator, index, visited) {
    if (currentLink && !visited.includes(currentLink.id)) {
      visited.push(currentLink.id);
      const node = this.nodes[currentLink.from.nodeId];
      const tmp = this.exportArgsAnalyzer(node);
      if (tmp) {
        accumulator.push(tmp);
      }
      this.recursiveSearch(
        this.links.find((o) => o.to.nodeId === node.id),
        accumulator,
        ++index,
        visited
      );
    }
    return index === 0 ? null : accumulator;
  }
  getModelAttributes(model) {
    const attributes = this.models.find((o) => o.name === model).attributes;
    return attributes.map((o) => ({ name: o.name, type: o.type }));
  }
  exportArgsAnalyzer(node) {
    const exportArgs = nodesTypes.find((o) => o.type === node.type).exportArgs;
    const nodeName = node.properties.name;
    const nodeArgs = node.properties.args;
    if (exportArgs && Object.keys(nodeArgs).length > 0) {
      const context = {
        node: nodeName,
        exported: {},
      };
      if (typeof exportArgs === "object") {
        for (const key in exportArgs) {
          if (Array.isArray(exportArgs[key])) {
            exportArgs[key].forEach((o) => {
              if (typeof o === "string") {
                if (nodeArgs && nodeArgs[key] && nodeArgs[key][o]) {
                  const data = nodeArgs[key][o];
                  if (this.modelsNames && this.modelsNames.includes(data)) {
                    const quantifier = nodeArgs[key].quantifier;
                    if (
                      quantifier &&
                      QUANTIFIERS.includes(quantifier) &&
                      quantifier === QUANTIFIER_MANY
                    ) {
                      context.exported[data] = { type: "array" };
                    } else {
                      context.exported[data] = this.getModelAttributes(data);
                    }
                  }
                }
              }
              if (typeof o === "object") {
                const type = nodeArgs[key][o.data];
                const data = o.mach.find((op) => op.type === type);
                if (data) {
                  context.exported[data.name] = { type: data[o.find] };
                }
              }
            });
          } else if (typeof exportArgs[key] === "object") {
            const data = nodeArgs[key];
            if (typeof data === "object") {
              if (exportArgs[key].define) {
                const name = data[exportArgs[key].define.source];
                context.exported[name] = { type: exportArgs[key].define.type };
              } else {
                for (const k in data) {
                  if (data[k].type) {
                    context.exported[k] = { type: data[k].type };
                  }
                }
              }
            }
          }
        }
      }
      return context;
    }
  }
}
